// Slicing ISODate returns format of YYYY-MM-dd
export const sliceTimeFromISODate = (ISODateString) => {
	if (typeof ISODateString !== 'string') {
		return null;
	}

	return ISODateString?.slice(0, 10);
};
